import React from 'react'
import PropTypes from 'prop-types'

import TableIndicator from '../TableIndicator'

/**
 *  IndicatorContainer
 */
const IndicatorContainer = ({ position, isVisitor, indicators }) => (
  <div className={position}>
    <div className="markers--layer">
      <div className="markers">
        <div className="markers--canvas">
          <TableIndicator indicators={indicators} isVisitor={isVisitor} color="normal" />
        </div>
      </div>
      <div className="markers">
        <div className="markers--canvas">
          <TableIndicator indicators={indicators} isVisitor={isVisitor} color="darkgreen" />
        </div>
      </div>
      <div className="markers">
        <div className="markers--canvas">
          <TableIndicator indicators={indicators} isVisitor={isVisitor} color="violet" />
        </div>
      </div>
      <div className="markers">
        <div className="markers--canvas">
          <TableIndicator indicators={indicators} isVisitor={isVisitor} color="blue" />
        </div>
      </div>
    </div>
  </div>
)

IndicatorContainer.propTypes = {
  position: PropTypes.string,
  isVisitor: PropTypes.bool,
  indicators: PropTypes.array,
}

export default IndicatorContainer
